<template>
  <div class="contact-slider" :class="{ active: active }">
    <div @click="active = !active" :class="{ active: active }" class="toggle">
      <span>{{ translations.title }}</span>
    </div>
    <form>
      <span class="subtitle">{{ translations.subtitle }}</span>

      <span v-show="errors.has('name') && submitted" class="form-error">{{
        errors.first("name")
      }}</span>
      <input
        v-model="form.name"
        v-validate="'required'"
        id="name"
        type="text"
        name="name"
        :placeholder="translations.name"
      />

      <span v-show="errors.has('email') && submitted" class="form-error">{{
        errors.first("email")
      }}</span>
      <input
        v-model="form.email"
        v-validate="'required'"
        id="email"
        type="email"
        name="email"
        :placeholder="translations.email"
      />

      <span v-show="errors.has('phone') && submitted" class="form-error">{{
        errors.first("phone")
      }}</span>
      <input
        id="phone"
        type="text"
        name="phone"
        v-model="form.phone"
        :placeholder="translations.number"
      />

      <textarea
        v-model="form.message"
        :placeholder="translations.message"
      ></textarea>

      <input type="hidden" id="gclid_field" name="gclid_field" value="" />

      <input type="hidden" id="cid_field" name="cid" value="" />

      <div class="terms">
        <div class="checkbox-wrapper">
          <input
            v-model="agreed_terms.status"
            type="checkbox"
            name="conditions"
            id="conditions"
            @change="agreed_terms.error = false"
          />
          <a target="_blank" :href="terms">
            {{ this.$translations.cart.terms_text }}
          </a>
        </div>
        <div
          class="form-error"
          v-if="agreed_terms.error && !agreed_terms.status"
        >
          {{ this.$translations.cart.terms_error }}
        </div>
      </div>
      <button @click.prevent="submit" :class="{ 'btn-loading': loading }">
        {{ translations.send }}
      </button>
    </form>
    <div class="form-error" v-if="error">
      {{ this.$translations.form.error }}
    </div>

    <div class="form-success" v-if="success">
      {{ this.$translations.form.post_success }}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);

export default {
  props: ["terms"],
  data() {
    return {
      active: false,
      translations: this.$translations.product.slide_in,
      form: {
        url: window.location.href,
      },
      loading: false,
      error: false,
      submitted: false,
      success: false,

      agreed_terms: {
        status: false,
        error: false,
      },
    };
  },
  methods: {
    submit() {
      this.submitted = true;
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.send();
        }
      });
    },
    async send() {
      this.loading = true;
      let formData = new FormData();
      let additionalData = {
        cid: document.querySelector("#cid_field").value,
        gclid: document.querySelector("#gclid_field").value,
        agreed: this.agreed_terms.status ? "agreed" : "not agreed",
      };

      Object.keys(this.form).forEach((key) =>
        formData.append(key, this.form[key])
      );

      Object.keys(additionalData).forEach((key) =>
        formData.append(key, additionalData[key])
      );

      if (this.agreed_terms.status) {
        await axios
          .post("https://mailer.signifly.com/api/klassik/mail", formData)
          .then((response) => {
            this.submitted = false;
            this.success = true;
            this.loading = false;
            this.form = {
              url: window.location.href,
            };
          })
          .catch((e) => {
            this.error = true;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-slider {
  position: fixed;
  top: 377px;
  right: -400px;
  transform: translateY(-50%);
  width: 400px;
  height: auto;
  padding: 40px;
  background: #fff;
  box-shadow: 20px 2px 35px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  transition: 0.5s;
  z-index: 10;

  &.active {
    right: 0;
  }

  @include res(mobile) {
    top: 340px;
    right: -260px;
    width: 260px;
    padding: 20px;
  }

  .subtitle {
    display: block;
    font-size: 15px;
    margin-bottom: 20px;
    font-family: $font-text-heavy;
    font-weight: lighter;
    color: $dark-grey;
    text-transform: uppercase;
    text-align: center;

    @include res(mobile) {
      margin-bottom: 15px;
    }
  }

  .terms {
    @include terms;
  }

  input,
  textarea {
    border: 1px solid rgba(121, 131, 149, 0.616);
    color: $dark-grey;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 20px;
    outline: none;
    margin-bottom: 20px;
    width: 100%;
    background-color: $white;

    @include res(mobile) {
      font-size: 14px;
      line-height: 18px;
      padding: 6px 10px;
      margin-bottom: 14px;
    }
  }

  textarea {
    height: 80px;
  }

  button {
    @include button(#ffffff, 12px, 25px);
    background-color: #798395;
    line-height: 20px;
    border: 0;
    width: 100%;

    &::before {
      @include button-hover($bg: #798395);
    }

    @include res(mobile) {
      @include button(#ffffff, 9px, 25px);
    }
  }

  .toggle {
    position: absolute;
    height: 40px;
    width: 180px;
    transform: rotate(90deg);
    text-align: center;
    cursor: pointer;
    background: #333538;
    top: 70px;
    left: -110px;
    line-height: 40px;

    @include ie {
      transform: rotate(0deg);
    }

    span {
      transform: rotate(90deg);
      color: $white;
    }

    @include res(tab-p) {
      height: 34px;
      width: 140px;
      top: 30%;
      left: -87px;
    }
  }
  div.form-success,
  div.form-error {
    margin-top: 8px;
  }
}
</style>
